export default "__VITE_ASSET__BZzCGGxS__"